import type { StringMap } from 'corgi-types';

import { fetchFromGql } from './fetch';
import type { GraphQLResponse } from './response';
import type { AssocMap, GqlRequestExtensions } from './types';

interface FetchFormDataGqlArgs<GqlVariables = unknown> {
  assocMap: AssocMap;
  query?: string;
  variables?: GqlVariables;
  extensions?: GqlRequestExtensions;
}

const getFormDataBody = <GqlVariables = unknown>({
  query,
  assocMap,
  variables,
  extensions,
}: FetchFormDataGqlArgs<GqlVariables>) => {
  const map: StringMap = {};
  const body = new FormData();

  body.append('operations', JSON.stringify({ query, variables, extensions }));

  assocMap.forEach(({ name }, key) => {
    map[name] = [`variables.${key}`];
  });

  body.append('map', JSON.stringify(map));

  assocMap.forEach(({ name, value }) => {
    body.append(name, value);
  });

  return body;
};

export const fetchFormDataGql = <ResponseData, GqlVariables = unknown>(
  args: FetchFormDataGqlArgs<GqlVariables>
) =>
  fetchFromGql<GraphQLResponse<ResponseData>>({
    body: getFormDataBody<GqlVariables>(args),
    method: 'post',
  });
